import ChapterBox from '../../components/admin/ChapterBox'
import AdminContentLayout from '../../components/layout/AdminContentLayout'
import AdminLayout from '../../components/layout/AdminLayout'

const Chapters = () => {
  return (
    <AdminLayout>
      <AdminContentLayout children={<ChapterBox />} />
    </AdminLayout>
  )
}

export default Chapters
